/**
 * Payload utility functions for PostHog events
 *
 * Story 4.1: PostHog Frontend Analytics
 */

import type { BaseEventPayload } from "./payload.types";

/**
 * Creates base payload with common properties from app state
 * Adds timestamp for deduplication
 */
export function createBasePayload(params: {
  userId?: string;
  userEmail?: string;
  language?: string;
}): BaseEventPayload {
  return {
    timestamp: new Date().toISOString(),
    userId: params.userId,
    userEmail: params.userEmail,
    language: params.language,
  };
}

/**
 * Removes timestamp from payload before sending to PostHog
 * Timestamp is only used for deduplication
 */
export function sanitizePayload<T extends BaseEventPayload>(
  payload: T
): Omit<T, "timestamp"> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { timestamp, ...rest } = payload;
  return rest as Omit<T, "timestamp">;
}

/**
 * Type guard to check if payload has required partnerId for NFC scan
 */
export function isValidNfcScanPayload(
  payload: unknown
): payload is { partnerId: string } {
  return (
    typeof payload === "object" &&
    payload !== null &&
    "partnerId" in payload &&
    typeof (payload as { partnerId: unknown }).partnerId === "string" &&
    (payload as { partnerId: string }).partnerId.length > 0
  );
}
